import Organization, { ParentCompany } from 'entities/organization/model';

export const matchCompanySso = (value = '', companies: (ParentCompany | Organization)[]) =>
  companies.find((company) => {
    if (!value || value?.length < 5) {
      return null;
    }

    const emailHost = value.split('@')[1]?.trim().toLowerCase();

    if (!emailHost) {
      return null;
    }

    return company.emailDomains?.includes(emailHost);
  });
